<template>
    <div>
        <ul class="list-inline text-center menu-top">
            <li v-for="(menu,index) in menuData" :key="index" :class="{active:$route.name === menu.url }">
                <router-link :to="'/' + menu.url">{{menu.name}}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import Menu from "@/fhMenu"
export default {
    data() {
        return {
            menuData: Menu.getMenu()
        }
    }
}
</script>
